<template>
  <div class="cjhc-control-container">
    <el-card class="container-card" shadow="hover">
      <el-form :inline="true" :model="searchForm" label-position="right" label-width="80px" class="search-form"
               style="display: flex; align-items: center; flex-wrap: nowrap; gap: 10px; overflow-x: auto;">

        <el-form-item label="用户标识" size="small" style="display: flex;align-items: center;">
          <el-input v-model="searchForm.userId" placeholder="请输入用户标识" clearable style="width: 200px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch" plain>搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button size="small" icon="el-icon-refresh" @click="resetSearch" plain>重置</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="warning" size="small" @click="batchUpdate" :disabled="selection.length === 0">
            批量修改({{selection.length}})
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="small" @click="exportExcel" :disabled="selection.length === 0">
            导出选中项
          </el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.7)"
        class="data-table"
        @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="55" align="center"></el-table-column>

        <el-table-column prop="id" label="ID" width="80" align="center" header-align="center"></el-table-column>
        <el-table-column prop="userId" label="用户标识" width="220" align="center" header-align="center"></el-table-column>

        <el-table-column prop="upProbability" label="设置概率(%)" width="200" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.upProbability"
              :min="0"
              :max="100"
              size="mini"
              @change="handleProbabilityChange(scope.row)">
            </el-input-number>
          </template>
        </el-table-column>

        <el-table-column prop="reportedCount" label="已上报数" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="totalCount" label="总数" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="upRate" label="上报率" width="180" align="center" header-align="center"></el-table-column>
        <el-table-column prop="eventType" label="上报行为" width="180" align="center" header-align="center">
          <template slot-scope="scope">
            {{ getEventTypeLabel(scope.row.eventType) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="400" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)" plain>编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)" plain>删除</el-button>
            <el-button size="mini" type="primary" plain @click="generateHandle(scope.row)">生成点击链接</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background small>
        </el-pagination>
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" @close="handleDialogClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
          <el-form-item label="用户标识" prop="userId">
            <el-input v-model="form.userId" placeholder="请输入用户标识" :disabled="isEditMode"></el-input>
          </el-form-item>
          <el-form-item label="设置概率(%)" prop="upProbability">
            <el-input v-model="form.upProbability" placeholder="请输入设置概率(%)"></el-input>
          </el-form-item>
          <el-form-item label="上报行为" prop="eventType">
            <el-select v-model="form.eventType" placeholder="请选择上报行为">
              <el-option label="激活" value="1"></el-option>
              <el-option label="下载完成" value="2"></el-option>
              <el-option label="页面浏览" value="3"></el-option>
              <el-option label="搜索" value="4"></el-option>
              <el-option label="表单提交" value="5"></el-option>
              <el-option label="电话拨打" value="6"></el-option>
              <el-option label="开始下载" value="7"></el-option>
              <el-option label="加入购物车" value="8"></el-option>
              <el-option label="加入心愿单" value="9"></el-option>
              <el-option label="下单购买" value="11"></el-option>
              <el-option label="注册(网页类)" value="12"></el-option>
              <el-option label="在线咨询" value="13"></el-option>
              <el-option label="其他" value="14"></el-option>
              <el-option label="首唤" value="15"></el-option>
              <el-option label="微信" value="18"></el-option>
              <el-option label="注册（应用类）" value="27"></el-option>
              <el-option label="一句话咨询" value="32"></el-option>
              <el-option label="三句话咨询" value="33"></el-option>
              <el-option label="启动小程序" value="34"></el-option>
              <el-option label="调起" value="50"></el-option>
              <el-option label="商品详情页" value="51"></el-option>
              <el-option label="深度页面访问" value="52"></el-option>
              <el-option label="领取卡券" value="53"></el-option>
              <el-option label="二跳广告点击（金额）" value="64"></el-option>
              <el-option label="微信关注" value="65"></el-option>
              <el-option label="微信付费" value="66"></el-option>
              <el-option label="快应用打开" value="67"></el-option>
              <el-option label="快应用加桌" value="68"></el-option>
              <el-option label="快应用付费" value="69"></el-option>
              <el-option label="创角" value="75"></el-option>
              <el-option label="获取验证码" value="76"></el-option>
              <el-option label="付费金额页面" value="77"></el-option>
              <el-option label="二跳广告曝光" value="79"></el-option>
              <el-option label="升级" value="81"></el-option>
              <el-option label="充值金额页面" value="82"></el-option>
              <el-option label="直播关注" value="83"></el-option>
              <el-option label="简历更新" value="84"></el-option>
              <el-option label="点击微信蓝色字体" value="85"></el-option>
              <el-option label="微信二维码展示" value="86"></el-option>
              <el-option label="微信识别二维码" value="87"></el-option>
              <el-option label="设备激活" value="98"></el-option>
              <el-option label="付费" value="1000"></el-option>
              <el-option label="次日留存" value="1001"></el-option>
              <el-option label="有效咨询" value="1002"></el-option>
              <el-option label="用户名片" value="1003"></el-option>
              <el-option label="有效电话" value="1004"></el-option>
              <el-option label="完件" value="1005"></el-option>
              <el-option label="预授信" value="1006"></el-option>
              <el-option label="授信" value="1007"></el-option>
              <el-option label="订单发货" value="1012"></el-option>
              <el-option label="订单签收" value="1013"></el-option>
              <el-option label="有效沟通" value="1014"></el-option>
              <el-option label="有效观看" value="1015"></el-option>
              <el-option label="放款" value="1016"></el-option>
              <el-option label="开户" value="1017"></el-option>
              <el-option label="添加企业微信" value="1021"></el-option>
              <el-option label="APP内下单" value="1022"></el-option>
              <el-option label="关键行为" value="1023"></el-option>
              <el-option label="老客付费" value="1024"></el-option>
              <el-option label="2日次留" value="1025"></el-option>
              <el-option label="3日留存" value="1026"></el-option>
              <el-option label="4日留存" value="1027"></el-option>
              <el-option label="5日留存" value="1028"></el-option>
              <el-option label="6日留存" value="1029"></el-option>
              <el-option label="7日留存" value="1030"></el-option>
              <el-option label="14日留存" value="1031"></el-option>
              <el-option label="30日留存" value="1032"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="批量修改设置" :visible.sync="batchDialogVisible" width="30%">
        <el-form label-width="100px">
          <el-form-item label="上报概率(%)">
            <el-input-number v-model="batchForm.upProbability" :min="0" :max="100"></el-input-number>
          </el-form-item>
          <el-form-item label="上报行为">
            <el-select v-model="batchForm.eventType">
              <el-option label="激活" value="1"></el-option>
              <el-option label="下载完成" value="2"></el-option>
              <el-option label="页面浏览" value="3"></el-option>
              <el-option label="搜索" value="4"></el-option>
              <el-option label="表单提交" value="5"></el-option>
              <el-option label="电话拨打" value="6"></el-option>
              <el-option label="开始下载" value="7"></el-option>
              <el-option label="加入购物车" value="8"></el-option>
              <el-option label="加入心愿单" value="9"></el-option>
              <el-option label="下单购买" value="11"></el-option>
              <el-option label="注册(网页类)" value="12"></el-option>
              <el-option label="在线咨询" value="13"></el-option>
              <el-option label="其他" value="14"></el-option>
              <el-option label="首唤" value="15"></el-option>
              <el-option label="微信" value="18"></el-option>
              <el-option label="注册（应用类）" value="27"></el-option>
              <el-option label="一句话咨询" value="32"></el-option>
              <el-option label="三句话咨询" value="33"></el-option>
              <el-option label="启动小程序" value="34"></el-option>
              <el-option label="调起" value="50"></el-option>
              <el-option label="商品详情页" value="51"></el-option>
              <el-option label="深度页面访问" value="52"></el-option>
              <el-option label="领取卡券" value="53"></el-option>
              <el-option label="二跳广告点击（金额）" value="64"></el-option>
              <el-option label="微信关注" value="65"></el-option>
              <el-option label="微信付费" value="66"></el-option>
              <el-option label="快应用打开" value="67"></el-option>
              <el-option label="快应用加桌" value="68"></el-option>
              <el-option label="快应用付费" value="69"></el-option>
              <el-option label="创角" value="75"></el-option>
              <el-option label="获取验证码" value="76"></el-option>
              <el-option label="付费金额页面" value="77"></el-option>
              <el-option label="二跳广告曝光" value="79"></el-option>
              <el-option label="升级" value="81"></el-option>
              <el-option label="充值金额页面" value="82"></el-option>
              <el-option label="直播关注" value="83"></el-option>
              <el-option label="简历更新" value="84"></el-option>
              <el-option label="点击微信蓝色字体" value="85"></el-option>
              <el-option label="微信二维码展示" value="86"></el-option>
              <el-option label="微信识别二维码" value="87"></el-option>
              <el-option label="设备激活" value="98"></el-option>
              <el-option label="付费" value="1000"></el-option>
              <el-option label="次日留存" value="1001"></el-option>
              <el-option label="有效咨询" value="1002"></el-option>
              <el-option label="用户名片" value="1003"></el-option>
              <el-option label="有效电话" value="1004"></el-option>
              <el-option label="完件" value="1005"></el-option>
              <el-option label="预授信" value="1006"></el-option>
              <el-option label="授信" value="1007"></el-option>
              <el-option label="订单发货" value="1012"></el-option>
              <el-option label="订单签收" value="1013"></el-option>
              <el-option label="有效沟通" value="1014"></el-option>
              <el-option label="有效观看" value="1015"></el-option>
              <el-option label="放款" value="1016"></el-option>
              <el-option label="开户" value="1017"></el-option>
              <el-option label="添加企业微信" value="1021"></el-option>
              <el-option label="APP内下单" value="1022"></el-option>
              <el-option label="关键行为" value="1023"></el-option>
              <el-option label="老客付费" value="1024"></el-option>
              <el-option label="2日次留" value="1025"></el-option>
              <el-option label="3日留存" value="1026"></el-option>
              <el-option label="4日留存" value="1027"></el-option>
              <el-option label="5日留存" value="1028"></el-option>
              <el-option label="6日留存" value="1029"></el-option>
              <el-option label="7日留存" value="1030"></el-option>
              <el-option label="14日留存" value="1031"></el-option>
              <el-option label="30日留存" value="1032"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="batchDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmBatchUpdate">确认</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="generateDialog" width="700px">
        <el-form :model="form2">
          <el-form-item>
            <div style="width: 100%;">
              <el-input v-model="form2.url" placeholder="请输入生成的链接" clearable
                        style="width: 80%; display: inline-block; vertical-align: middle;" />
              <el-button type="primary" @click="fuzhicopy"
                         style="display: inline-block; vertical-align: middle; margin-left: 10px;">
                复制
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { get, post } from '../../until/controlRequest'
import { exportJsonToExcel } from '../../until/export2Excel'

export default {
  name: 'CjhcClickControl',
  data() {
    return {
      generateDialog: false,
      form2: {},
      searchForm: {
        userId: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增控制信息',
      form: {
        id: null,
        userId: '',
        upProbability: '',
        eventType: '1'
      },
      rules: {
        userId: [
          { required: true, message: '请输入用户标识', trigger: 'blur' }
        ],
        upProbability: [
          { required: true, message: '请输入设置概率(%)', trigger: 'blur' },
          {
            validator: this.validateProbability,
            trigger: 'blur'
          }
        ]
      },
      isEditMode: false,

      selection: [],
      batchDialogVisible: false,
      batchForm: {
        upProbability: 50,
        eventType: '1'
      },
      clickLinks: {}
    }
  },
  created() {
    this.fetchPage()
  },
  methods: {

    handleSelectionChange(val) {
      this.selection = val
    },

    batchUpdate() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }
      this.batchDialogVisible = true
    },

    confirmBatchUpdate() {
      const params = this.selection.map(item => ({
        id: item.id,
        userUuid: item.userUuid,
        upProbability: this.batchForm.upProbability,
        eventType: this.batchForm.eventType
      }))
      post('/v1/cjhc/control/batchUpdate', params)
        .then(() => {
          this.$message.success('批量修改成功')
          this.fetchPage()
          this.batchDialogVisible = false
        })
        .catch(() => {
          this.$message.error('批量修改失败')
        })
    },

    getEventTypeLabel(value) {
      const eventTypeMap = {
        '1': '激活',
        '2': '下载完成',
        '3': '页面浏览',
        '4': '搜索',
        '5': '表单提交',
        '6': '电话拨打',
        '7': '开始下载',
        '8': '加入购物车',
        '9': '加入心愿单',
        '11': '下单购买',
        '12': '注册(网页类)',
        '13': '在线咨询',
        '14': '其他',
        '15': '首唤',
        '18': '微信',
        '27': '注册（应用类）',
        '32': '一句话咨询',
        '33': '三句话咨询',
        '34': '启动小程序',
        '50': '调起',
        '51': '商品详情页',
        '52': '深度页面访问',
        '53': '领取卡券',
        '64': '二跳广告点击（金额）',
        '65': '微信关注',
        '66': '微信付费',
        '67': '快应用打开',
        '68': '快应用加桌',
        '69': '快应用付费',
        '75': '创角',
        '76': '获取验证码',
        '77': '付费金额页面',
        '79': '二跳广告曝光',
        '81': '升级',
        '82': '充值金额页面',
        '83': '直播关注',
        '84': '简历更新',
        '85': '点击微信蓝色字体',
        '86': '微信二维码展示',
        '87': '微信识别二维码',
        '98': '设备激活',
        '1000': '付费',
        '1001': '次日留存',
        '1002': '有效咨询',
        '1003': '用户名片',
        '1004': '有效电话',
        '1005': '完件',
        '1006': '预授信',
        '1007': '授信',
        '1012': '订单发货',
        '1013': '订单签收',
        '1014': '有效沟通',
        '1015': '有效观看',
        '1016': '放款',
        '1017': '开户',
        '1021': '添加企业微信',
        '1022': 'APP内下单',
        '1023': '关键行为',
        '1024': '老客付费',
        '1025': '2日次留',
        '1026': '3日留存',
        '1027': '4日留存',
        '1028': '5日留存',
        '1029': '6日留存',
        '1030': '7日留存',
        '1031': '14日留存',
        '1032': '30日留存'
      }
      return eventTypeMap[value] || value
    },

    // 概率校验方法
    validateProbability(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入设置概率(%)'));
        return;
      }

      const numValue = Number(value);

      // 检查是否为有效数字
      if (isNaN(numValue)) {
        callback(new Error('请输入有效的数字'));
        return;
      }

      // 检查是否在0-100范围内
      if (numValue < 0 || numValue > 100) {
        callback(new Error('概率值必须在0-100之间'));
        return;
      }

      // 检查小数位数是否超过两位
      const strValue = String(value);
      if (strValue.includes('.')) {
        const decimalPart = strValue.split('.')[1];
        if (decimalPart.length > 2) {
          callback(new Error('概率值最多保留两位小数'));
          return;
        }
      }

      callback();
    },

    // 新增方法 - 导出Excel
    exportExcel() {
      if (this.selection.length === 0) {
        this.$message.warning('请至少选择一条记录')
        return
      }
      const tHeader = ['ID', '用户标识', '设置概率(%)', '已上报数', '总数', '上报率', '上报行为', '点击链接']
      const filterVal = ['id', 'userId', 'upProbability', 'reportedCount', 'totalCount', 'upRate', 'eventType', 'clickLink']
      const data = this.selection.map(item => {
        return {
          ...item,
          eventType: this.getEventTypeLabel(item.eventType),
          clickLink: this.clickLinks[item.id] || '未生成链接'
        }
      })
      exportJsonToExcel({
        header: tHeader,
        data,
        key: filterVal,
        filename: 'CJHC控制数据_' + new Date().toLocaleDateString()
      })
    },

    generateHandle(row) {
      this.$message.success('生成成功')
      this.generateDialog = true
      const url = `https://control.zjwec.cn/api/v1/cjhc/click/save?&adid={AID}&cid={CID}&advertiserId={ACID}&groupId={GID}&idfa={IDFA1}&idfaMd5={IDFA_SUM}&oaid={OAID}&os={OS}&callbackUrl={CALLBACK_URL}&imei={IMEI_SUM1}&imeiMd5={IMEI_SUM}&ua={UA}&timestamp={UX_TS}&caid={CAID}&oaidMd5={OAID_SUM}&IP={IP}&kehu=${row.userUuid}`
      this.form2.url = url
      this.$set(this.clickLinks, row.id, url)
    },

    handleProbabilityChange(row) {
      post('/v1/cjhc/control/update', {
        id: row.id,
        userUuid: row.userUuid,
        upProbability: row.upProbability,
        eventType: row.eventType
      }).then(() => {
        this.$message.success('概率更新成功')
      })
    },

    handleTypeChange(row) {
      post('/v1/cjhc/control/update', {
        id: row.id,
        userUuid: row.userUuid,
        upProbability: row.upProbability,
        eventType: row.eventType
      }).then(() => {
        this.$message.success('转化类型更新成功')
      })
    },


    async fuzhicopy() {
      try {
        await navigator.clipboard.writeText(this.form2.url);
        this.$message.success('复制成功');
      } catch (err) {
        console.error('复制失败', err);
        this.$message.error('复制失败，请手动复制');
      }
    },
    fetchPage() {
      this.loading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        userId: this.searchForm.userId
      }
      get('/v1/cjhc/control/page', params)
        .then(data => {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        })
        .catch(() => {
          this.tableData = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchPage()
    },
    resetSearch() {
      this.searchForm = {
        userId: ''
      }
      this.handleSearch()
    },
    handleAdd() {
      this.dialogTitle = '新增控制信息'
      this.form = {
        id: null,
        userId: '',
        upProbability: '',
        eventType: '1'
      }
      this.isEditMode = false
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑控制信息'
      this.form = {
        id: row.id,
        userId: row.userId,
        userUuid: row.userUuid,
        upProbability: row.upProbability,
        eventType: String(row.eventType),
      }
      this.isEditMode = true
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const api = this.form.id ? '/v1/cjhc/control/update' : '/v1/cjhc/control/insert'
        post(api, this.form)
          .then(() => {
            this.$message.success(this.form.id ? '更新成功' : '新增成功')
            this.dialogVisible = false
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error(this.form.id ? '更新失败' : '新增失败')
          })
      })
    },
    handleDelete(row) {
      this.$confirm(`确定要删除用户标识为 "${row.userId}" 的控制信息吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post(`/v1/cjhc/control/delete?userUuid=${row.userUuid}`)
          .then(() => {
            this.$message.success('删除成功')
            this.fetchPage()
          })
          .catch(() => {
            this.$message.error('删除失败')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchPage()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.fetchPage()
    }
  }
}
</script>

<style scoped>
.cjhc-control-container {
  padding: 20px;
}

.container-card {
  min-height: calc(100vh - 90px);
}

.search-form {
  margin-bottom: 20px;
}

.data-table {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: center;
  margin-top: 20px;
}

.el-button--warning {
  margin-left: 10px;
}

.el-button--success {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/cjhc/CjhcClickControl.vue